const { REACT_APP_ASSET_URL } = process.env;

const SLICEADBOX_DATA = [
    {
        imgSrc: `${REACT_APP_ASSET_URL}/how-it-works/adv-1.png?updatedAt=1700746159473`,

        title: "Wealth Creation",
        para: "Despite its popularity as wealth creator, real estate has only been accessible to the top 5% due to its investment challenges. Slice levels the playing field so everyone can climb the wealth creation ladder via real estate investments."
    },
    {
        imgSrc: `${REACT_APP_ASSET_URL}/how-it-works/adv-2.png?updatedAt=1700746159539`,
        title: "Effortless Experience",
        para: "Having understood all elements of the real estate investment process, we have designed a unique and seamless customer journey on a single app that takes you from initial sign up through to making your first investment and beyond – with Slice, you are at the center of everything we do."
    },
    {
        imgSrc: `${REACT_APP_ASSET_URL}/how-it-works/adv-3.png?updatedAt=1700746159539`,
        title: "Regulated & Secure",
        para: "This new model may sound too good to be true. Don’t worry we have worked hard to change this market for the better. We are regulated by the Dubai Financial Services Authority (DFSA) for your added protection. Your investments are fully protected by this regulatory license."
    },
]

export default SLICEADBOX_DATA;